// Utility function to initialize or destroy Swiper instances
function handleResponsiveSwiper(selector, config, breakpoint = 768) {
    let swiperInstance = null;

    const initSwiper = () => {
        if (window.innerWidth <= breakpoint) {
            if (!swiperInstance) {
                swiperInstance = new Swiper(selector, config);
            }
        } else if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    };

    // Initialize on load
    initSwiper();

    // Re-check on window resize
    window.addEventListener("resize", initSwiper);
}

// Top Slider Initialization
new Swiper(".js-slideBanner", {
    loop: true,
    slidesPerView: 1.2,
    allowTouchMove: true,
    pagination: {
        el: ".p-frontBanner .swiper-pagination",
    },
    navigation: {
        nextEl: ".p-frontBanner__button .swiper-button-next",
        prevEl: ".p-frontBanner__button .swiper-button-prev",
    },
    breakpoints: {
        569: { slidesPerView: 2.5 },
        769: { slidesPerView: 2.3 },
    },
});

// Hospital Slider Initialization
new Swiper(".js-topHospital", {
    loop: true,
    slidesPerView: 1.2,
    centeredSlides: true,
    speed: 6000,
    allowTouchMove: false,
    autoplay: { delay: 0 },
    breakpoints: {
        569: { slidesPerView: 2.5 },
        769: { slidesPerView: 3.8 },
    },
});

// Responsive Swiper Instances
const responsiveConfigs = [
    {
        selector: ".js-slideReviewSP",
        config: {
            slidesPerView: 1.4,
            spaceBetween: 28,
            centeredSlides: true,
            navigation: {
                nextEl: ".p-frontReview__button .swiper-button-next",
                prevEl: ".p-frontReview__button .swiper-button-prev",
            },
        },
    },
    {
        selector: ".js-slideProfileSP",
        config: {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 30,
            pagination: {
                el: ".c-profile-list__pagination .swiper-pagination",
            },
            navigation: {
                nextEl: ".c-profile-list__button .swiper-button-next",
                prevEl: ".c-profile-list__button .swiper-button-prev",
            },
            loop: true,
        },
    },
    {
        selector: ".js-slideProcessSP",
        config: {
            slidesPerView: 1.2,
            spaceBetween: 40,
            pagination: {
                el: ".c-process__pagination .swiper-pagination",
            },
            navigation: {
                nextEl: ".c-process__button .swiper-button-next",
                prevEl: ".c-process__button .swiper-button-prev",
            },
            breakpoints: {
                569: { slidesPerView: 2.5 },
            },
        },
    },
];

// Initialize all responsive Swipers
responsiveConfigs.forEach(({ selector, config }) => handleResponsiveSwiper(selector, config));
